import React from 'react';
import { CheckCircle } from 'lucide-react';
const CHECKOUT_URL = 'https://maestros.ebookditales.com/cart/44752368664712:1';
interface BonusCardProps {
  title: string;
  benefits: string[];
  imageUrl: string;
  bonoNumber: number;
}
export function BonusCard({
  title,
  benefits,
  imageUrl,
  bonoNumber
}: BonusCardProps) {
  const handleClick = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  return <div onClick={handleClick} className="cursor-pointer group bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200 hover:shadow-2xl transition-all duration-300 hover:scale-[1.02]" data-id="element-222">
      {/* Image Container */}
      <div className="relative bg-gradient-to-br from-purple-50 to-white p-4" data-id="element-223">
        <div className="absolute top-3 left-3 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-224">
          Bono {bonoNumber}
        </div>
        <div className="absolute top-3 right-3 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider animate-pulse" data-id="element-225">
          Gratis Hoy
        </div>
        <img src={imageUrl} alt={title} className="w-full h-auto max-h-[300px] object-contain mx-auto drop-shadow-xl" data-id="element-226" />
      </div>

      <div className="p-6" data-id="element-227">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-228">{title}</h3>
        <ul className="space-y-2" data-id="element-229">
          {benefits.map((benefit, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-600" data-id="element-230">
              <CheckCircle className="w-4 h-4 text-purple-500 shrink-0 mt-0.5" data-id="element-231" />
              <span data-id="element-232">{benefit}</span>
            </li>)}
        </ul>
        <div className="mt-4 pt-4 border-t border-gray-100 text-center" data-id="element-233">
          <span className="text-green-600 font-bold text-lg" data-id="element-234">
            🎁 INCLUIDO GRATIS
          </span>
        </div>
      </div>
    </div>;
}